(function($) {
	// PDF FLIPBOOK CUSTOM JQUERY
  $(document).ready(function () {
		console.log('from brochures.js');

    if (document.querySelector("section.brochures") !== null) {
      // load the default waterboys pdf
      var default_option_pdf = {
        webgl: true,
        height: "150%",
        scrollWheel: false,
      };
      var default_source = $(".default_file").attr("data-pdf");
      var flipBook_pdf = $("#flipbookPDFContainer").flipBook(
        default_source,
        default_option_pdf
      );
      $(".pdf-viewer-links a").on("click", function (e) {
        e.preventDefault();
        var pdf_url = $(this).attr("data-pdf");

        $(".pdf-viewer-links a").removeClass("active");
        $(this).toggleClass("active");
        $(".default_file").removeClass("active");

        //FOR PDFs
        var source_pdf = pdf_url;
        var option_pdf = { webgl: true, height: "150%" };
        $(".df-3dcanvas").remove();
        // flipBook_pdf.dispose();

        var flipBook_pdf = $("#flipbookPDFContainer").flipBook(
          source_pdf,
          option_pdf
        );
      });
      $(".default_file").on("click", function (e) {
        e.preventDefault();
        var pdf_url = $(this).attr("data-pdf");
        $(".pdf-viewer-links a").removeClass("active");
        $(this).toggleClass("active");

        //FOR PDFs
        var source_pdf = pdf_url;
        var option_pdf = { webgl: true, height:'150%' };
        $(".df-3dcanvas").remove();
        // flipBook_pdf.dispose();

        var flipBook_pdf = $("#flipbookPDFContainer").flipBook(
          source_pdf,
          option_pdf
        );
      });
    }
  });
})(jQuery);